import { combineReducers } from 'redux';
import docListReducer from './doc-list';
import docViewReducer from './doc-view';
import packageListReducer from './package-list';
import packageViewReducer from './package-view';
import problemReducer from './problem';

const rootReducer = combineReducers(
    {
        docList     : docListReducer,
        docView     : docViewReducer,
        packageList : packageListReducer,
        packageView : packageViewReducer,
        problem     : problemReducer
    }
);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/lib/reducers/root.js